import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import {General} from '../../interfaces/general'
import { SolicitudesService } from '../../servicios/solicitudes.service';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {ConfirmacionValidarComponent} from '../confirmacion-validar/confirmacion-validar.component'
import {DocumentacionFormComponent} from '../documentacion-form/documentacion-form.component'
import {ModalComponent} from '../modal/modal.component'
import { PersonasViviendaComponent } from '../personas-vivienda/personas-vivienda.component';
import { ConvocatoriasService } from '../../servicios/convocatorias.service';


@Component({
	selector: 'app-solicitudes',
	templateUrl: './solicitudes.component.html',
	styleUrls: ['./solicitudes.component.css']
})
export class SolicitudesComponent implements OnInit {
	@ViewChild(PersonasViviendaComponent) child:PersonasViviendaComponent;
	moduleName = 'Gestión de Solicitudes';
	componentName = 'Solicitud Única de Crédito';
	catalogos: General
	isloadingEstados = false
	loading = false
	estructuraSolicitud
	SolicitanteFormulario: FormGroup;
	prevFormData;
	estatusPapa = false
	estatusMama = false
	estatusTutor = false
	tieneCURPSolicitante = false
	esEdicion = true
	showImageUpload = true;
	curpsEnSolicitud = []
	curpsEnPersonaVivienda = []
	curpsReferenciasPersonales = []
	curpsReferenciasFamiliares = []
	docsProps = []
	archivosId = []
	docsUrl = []
	fileNames = []
	personaVivienda
	href: string = "";
	tramiteID
	esConsulta
    rfcExpression = '^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A]|[0-9]){1})?$';




	estados: Array<any> = []
	constructor(private serviciosGenerales : ServiciosGeneralesService,
				private serviciosSolicitud: SolicitudesService,
				private formBuilder: FormBuilder,
				private snackBar: MatSnackBar,
				private router: ActivatedRoute,
				public dialog: MatDialog,
				private routerActual: Router,
				private convocatoriaService : ConvocatoriasService,
				private dialogo: MatDialog) {
					this.crearFormulario();
					this.prevFormData = this.SolicitanteFormulario.getRawValue();
					const form = this.SolicitanteFormulario.get('PreguntasUnicas') as FormGroup ;
					form.addControl('pregunta', new FormControl('test', Validators.required))
				}

	ngOnInit(): void {

		this.obtenerListaEstados();
		this.catalogosGenerales();
		this.obtenerID()

	}
	solicitanteValueChange(e) {
		this.curpsEnSolicitud = []
		this.curpsEnPersonaVivienda = []
		this.curpsReferenciasFamiliares = []
		this.curpsReferenciasPersonales = []

			if(this.SolicitanteFormulario.get('DatosSolicitante.Personas_CURP').value !== "") {
				this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosSolicitante.Personas_CURP').value)
			}

			if(this.SolicitanteFormulario.get('DatosSolicitante.Personas_CURP').value !== "") {
				this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosSolicitante.Personas_CURP').value)
			}

			if(this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').value !== "") {
				this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').value)
			}

			if(this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').value !== "") {
				this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').value)
			}

			if(this.SolicitanteFormulario.get('DatosTutor.Personas_CURP').value !== "") {
				this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosTutor.Personas_CURP').value)
			}
			if(this.SolicitanteFormulario.get('ListaDatosAval.Personas_CURP').value !== "") {
				this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('ListaDatosAval.Personas_CURP').value)
			}
			this.SolicitanteFormulario.get('PersonasVivienda.ListaPersonasVivienda').value.forEach(persona => {
				if(persona.Personas_CURP !== "") {
					this.curpsEnPersonaVivienda.push(persona.Personas_CURP)
				}
			});
			this.SolicitanteFormulario.get('ListaReferenciasFamiliares').value.forEach(persona => {
				if(persona.Personas_CURP !== "") {
					this.curpsReferenciasFamiliares.push(persona.Personas_CURP)
				}
			});
			this.SolicitanteFormulario.get('curpsReferenciasPersonales').value.forEach(persona => {
				if(persona.Personas_CURP !== "") {
					this.curpsReferenciasFamiliares.push(persona.Personas_CURP)
				}
			});


	}
	obtenerID() {
		this.router.paramMap.subscribe(params => {
			this.href = this.routerActual.url

			console.log(this.href)
			if (params.has('id')) {
				this.tramiteID = + params.get('id');
				this.serviciosSolicitud.obtenersolicitudId(this.tramiteID).subscribe(res => {
					this.esConsulta = true
					this.setSolicitud(res)
					this.esEdicion = this.href.includes('edit')
					if(!this.esEdicion) {
						this.SolicitanteFormulario.disable()
					}

				})

			}else {
				this.esEdicion = true
			}
		});
	}
	ngOnChanges(changes) {
	}
	 quitarValidaciones(form: FormGroup) {
		for (const key in form.controls) {
			 form.get(key).clearValidators();
			 form.get(key).updateValueAndValidity();
		}
	}
	agregarValidaciones(form: FormGroup) {
        for (const key in form.controls) {
             form.get(key).setValidators([Validators.required]);
             form.get(key).updateValueAndValidity();
    }
}

	verSituacionPadres() {
		if(this.SolicitanteFormulario.get('DatosSolicitante').value.Solicitante_SituacionPadreID === 1002) {
			this.estatusPapa = true
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').setValidators(Validators.required)
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').updateValueAndValidity()
		} else {
			this.estatusPapa = false
			this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_ApellidoPaterno').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_Nombre').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_ApellidoMaterno').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_EntidadFederativaID').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_MunicipioID').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_PaisID').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').setValidators([])
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').updateValueAndValidity()
			this.SolicitanteFormulario.get('DatosPadre.Personas_Genero').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_FechaNacimiento').setValue('')

		}

		if(this.SolicitanteFormulario.get('DatosSolicitante').value.Solicitante_SituacionMadreID === 1002 ) {
			this.estatusMama = true
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').setValidators(Validators.required)
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').updateValueAndValidity()
		} else {
			this.estatusMama = false
			this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_ApellidoPaterno').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_ApellidoMaterno').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_Nombre').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_EntidadFederativaID').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_MunicipioID').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_PaisID').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_Genero').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_FechaNacimiento').setValue('')

		}
		// this.crearFormulario()

		if( this.SolicitanteFormulario.get('DatosSolicitante').value.Personas_Edad < 18) {
			this.estatusTutor = true
		}else {
			this.quitarValidaciones(this.SolicitanteFormulario.get('DatosTutor') as FormGroup)
		}

	}
	confirmacionValidacion() {
		const dialogRef = this.dialog.open(ConfirmacionValidarComponent, {
			width: '250px',
		});
		dialogRef.afterClosed().subscribe(res => {
			console.log(res)
			if(res) {
				this.validar()
			}
		})
	}

	enviarDocumentacion() {
		const dialogRef = this.dialog.open(DocumentacionFormComponent , {
			width: '250px',
			data: this.tramiteID
		})
	}

	validar() {
		this.serviciosSolicitud.enviarValidada(this.tramiteID).subscribe(res => {
			console.log(res)
			this.openSnackBar(res.Message,'Entendido')
		},
		error => {
			console.log(error)
			this.openSnackBar(error.error.Message,'Entendido')
		})
	}
	escucharEstatusPapa(estatus) {
		console.log(estatus)
		this.estatusPapa = estatus
		const index = this.curpsEnSolicitud.indexOf(this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').value)
			if(index > -1) this.curpsEnSolicitud.splice(index,1);
		if(!this.estatusPapa) {
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').setValidators(null)
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').updateValueAndValidity()
			this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').setValue('',{emitEvent:false,emitModelToViewChange:false})
			this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').setValidators(null)
			this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').updateValueAndValidity({emitEvent:false})
			this.SolicitanteFormulario.get('DatosPadre.Personas_Nombre').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_ApellidoPaterno').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_ApellidoMaterno').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_EntidadFederativaID').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_MunicipioID').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_PaisID').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').setValue('')
			this.SolicitanteFormulario.get('DatosPadre.Personas_Genero').setValue(0)
			this.SolicitanteFormulario.get('DatosPadre.Personas_FechaNacimiento').setValue('')
		} else {
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').setValidators([Validators.required])
			this.SolicitanteFormulario.get('DatosPadre.Personas_EstadoCivilID').updateValueAndValidity()
			this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').setValidators([Validators.required])
			this.SolicitanteFormulario.get('DatosPadre.Personas_CURP').updateValueAndValidity({emitEvent:false})

		}
		if(this.SolicitanteFormulario.get('DatosSolicitante').value.Personas_Edad < 18) {
			this.estatusTutor = true
		}
		else {
			this.estatusTutor = false
		}
	}
	escucharEstatusMama(estatus) {
		console.log(estatus)
		this.estatusMama = estatus
		if(!this.estatusMama) {
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').setValidators(null)
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').updateValueAndValidity()
			const index = this.curpsEnSolicitud.indexOf(this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').value)
			if(index > -1) this.curpsEnSolicitud.splice(index,1);
			this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').setValue('',{emitEvent:false,emitModelToViewChange:false})
			this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').setValidators(null)
			this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').updateValueAndValidity({emitEvent:false})
			this.SolicitanteFormulario.get('DatosMadre.Personas_Nombre').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_ApellidoPaterno').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_ApellidoMaterno').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_EntidadFederativaID').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_MunicipioID').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_PaisID').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_Genero').setValue(0)
			this.SolicitanteFormulario.get('DatosMadre.Personas_FechaNacimiento').setValue('')
			this.SolicitanteFormulario.get('DatosMadre.Personas_Edad').setValue(0)
		} else {
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').setValidators([Validators.required])
			this.SolicitanteFormulario.get('DatosMadre.Personas_EstadoCivilID').updateValueAndValidity()
			this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').setValidators([Validators.required])
			this.SolicitanteFormulario.get('DatosMadre.Personas_CURP').updateValueAndValidity({emitEvent:false})

		}
		if(this.SolicitanteFormulario.get('DatosSolicitante').value.Personas_Edad < 18) {
			this.estatusTutor = true
		}
		else {
			this.estatusTutor = false

		}
	}

	catalogosGenerales() {
		this.serviciosGenerales.ListadoCatalogosGenerales().subscribe((res) => {
			this.catalogos = res
			this.loading = true
		})
	}

	removerReferencia(e) {
		console.log(e)
		if(e.tipo) {
			this.ReferenciasFamiliaresArray.removeAt(e.posicion);
		} else {
			this.ListaReferenciasPersonalesArray.removeAt(e.posicion);
		}

	}

	agregarReferencia(tipo) {
		console.log(tipo)
		if(tipo) {
			this.ReferenciasFamiliaresArray.push(this.listaReferenciasFamiliares())
		} else {
			this.ListaReferenciasPersonalesArray.push(this.listaReferenciasFamiliares())
		}
	}

	upsert () {
		let solicitud = this.SolicitanteFormulario.getRawValue()
		solicitud.ListaDatosAval = [solicitud.ListaDatosAval]
		console.log(solicitud.DatosSolicitante.ListaDiscapacidades)
		if(solicitud.DatosSolicitante.ListaDiscapacidades !== null) {
			if(solicitud.DatosSolicitante.ListaDiscapacidades.length >= 0) {
				solicitud.DatosSolicitante.ListaDiscapacidades = solicitud.DatosSolicitante.ListaDiscapacidades.filter(data => {
					return data.GradoID !== 0 && data.CausaID !== 0 ? true : false;
				})
			}
		}

		solicitud.ListaDatosAval.forEach(aval => {
			if(  aval.Direccion.Direcciones_CalleID !== null) {
				aval.Direccion.Direcciones_CalleID = aval.Direccion.Direcciones_CalleID.ID
			}
			if(aval.Direccion.Direcciones_LocalidadID !== null) {
				aval.Direccion.Direcciones_LocalidadID = aval.Direccion.Direcciones_LocalidadID.ID
			}
			if(  aval.Empresa_Direccion.Direcciones_CalleID !== null) {
				aval.Empresa_Direccion.Direcciones_CalleID = aval.Empresa_Direccion.Direcciones_CalleID.ID
			}
			if(aval.Empresa_Direccion.Direcciones_LocalidadID !== null) {
				aval.Empresa_Direccion.Direcciones_LocalidadID = aval.Empresa_Direccion.Direcciones_LocalidadID.ID
			}

		});
		solicitud.ListaReferenciasFamiliares.forEach(refFamiliar => {
			if(  refFamiliar.Direccion.Direcciones_CalleID !== null) {
				refFamiliar.Direccion.Direcciones_CalleID = refFamiliar.Direccion.Direcciones_CalleID.ID
			}
			if(refFamiliar.Direccion.Direcciones_LocalidadID !== null) {
				refFamiliar.Direccion.Direcciones_LocalidadID = refFamiliar.Direccion.Direcciones_LocalidadID.ID
			}
		});
		solicitud.ListaReferenciasPersonales.forEach(refPersona => {
			if(  refPersona.Direccion.Direcciones_CalleID !== null) {
				refPersona.Direccion.Direcciones_CalleID = refPersona.Direccion.Direcciones_CalleID.ID
			}
			if(refPersona.Direccion.Direcciones_LocalidadID !== null) {
				refPersona.Direccion.Direcciones_LocalidadID = refPersona.Direccion.Direcciones_LocalidadID.ID
			}
		});
		if(  solicitud.DatosSolicitante.Direccion.Direcciones_CalleID !== null) {
			solicitud.DatosSolicitante.Direccion.Direcciones_CalleID = solicitud.DatosSolicitante.Direccion.Direcciones_CalleID.ID
		}
		if(  solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID !== null) {
			solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID = solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID.ID
		}
		console.log(solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID)
		if(solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID !== null) {
			solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID = solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID.ID
		}

		// solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID = solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID.ID

		solicitud.PersonasVivienda.ListaEgresoMensuales = solicitud.PersonasVivienda.ListaEgresoMensuales.filter(egreso => {
			return egreso.EgresoMonto > 0 ? true : false;
		})
		solicitud.PersonasVivienda.ListaEgresoFamiliares = solicitud.PersonasVivienda.ListaEgresoFamiliares.filter(egreso => {
			return egreso.EgresoMonto > 0 ? true : false;
		})



		console.log(solicitud.PersonasVivienda.ListaEgresoMensuales)
		// solicitud.PersonasVivienda.ListaEgresoFamiliares = solicitud.PersonasVivienda.ListaEgresoMensuales
		let validation = true



			if(solicitud.ListaDatosAval[0].DatosContacto_TelefonoFijo === solicitud.ListaDatosAval[0].DatosContacto_TelefonoCelular) {
				this.openSnackBar('El numero telefonico fijo y de celular del aval no tienen que ser iguales','Entendido')
				validation = false
			}
			if(solicitud.DatosSolicitante.DatosContacto_TelefonoFijo === solicitud.DatosSolicitante.DatosContacto_TelefonoCelular) {
				this.openSnackBar('El numero telefonico fijo y de celular del Solicitante no tienen que ser iguales','Entendido')
				validation = false
			}

			if(solicitud.DatosSolicitante.Personas_EntidadFederativaID !== 1012 && solicitud.DatosSolicitante.Personas_TiempoResidencia < 2) {
				this.openSnackBar('El tiempo de residencia del solicitande tiene que ser mayor a 2 años','Entendido')
				validation = false
			}
			if(solicitud.DatosSolicitante.confirmarCelular !== solicitud.DatosSolicitante.DatosContacto_TelefonoCelular) {
				this.openSnackBar('El celular del solicitante no coincide con la verificacion','Entendido')
				 validation = false
			}
			if(solicitud.DatosSolicitante.DatosContacto_Correo !== solicitud.DatosSolicitante.DatosContacto_Correo_Confimacion && validation ) {
				this.openSnackBar('El correo del solicitante no coincide con la verificacion','Entendido')
				validation = false;
			}
			if(solicitud.ListaDatosAval.confirmarCelular !== solicitud.ListaDatosAval.DatosContacto_TelefonoCelular) {
				this.openSnackBar('El telefono celular del aval no coincide con la verificación','Entendido')
				validation = false
			}
			if(solicitud.ListaReferenciasFamiliares.lenght === 0) {
				this.openSnackBar('La solicitud requiere al menos 1 referencia familiar','Entendido')
				validation = false
			}
			if(solicitud.ListaReferenciasPersonales.lenght === 0) {
				this.openSnackBar('La solicitud requiere al menos 1 referencia personal','Entendido')
				validation = false
			}
			if(solicitud.DatosSolicitante.AplicaDiscapacidades && solicitud.DatosSolicitante.ListaDiscapacidades.lenght <= 0) {
				this.openSnackBar('La solicitud requiere al menos 1 una discapacidad','Entendido')
				validation = false
			}
			if(+solicitud.DatosEscolaresLaborales.DatosEscolares_TotalPeriodos < solicitud.DatosEscolaresLaborales.DatosEscolares_PeriodoActual) {
				this.openSnackBar('El total de periodos no debe de ser mayor que el periodo actual','Entendido')
				validation = false
			}
			solicitud.ListaReferenciasFamiliares.forEach((familiar,i) => {
				if(familiar.DatosContacto_TelefonoCelular !== familiar.confirmarCelular) {
				this.openSnackBar('El telefono celular del la referencia familiar' +i + 1+ 'no coincide con la verificación','Entendido')
					validation = false
				}
			});
			solicitud.ListaReferenciasPersonales.forEach((persona,i) => {
				if(persona.DatosContacto_TelefonoCelular !== persona.confirmarCelular) {
				this.openSnackBar('El telefono celular del la referencia personal' +i + 1+ 'no coincide con la verificación','Entendido')

					validation = false
				}
			});

			let expression = new RegExp(this.rfcExpression)
			if(expression.exec(solicitud.ListaDatosAval[0].Persona_RFC) ) {
				this.openSnackBar('El rfc del aval no es valido','Entendido')
			}
			// let dialogoRef = this.dialogo.open(ModalComponent, {
			// 	disableClose: true,
			// });
			if(validation) {
				this.serviciosSolicitud.enviar(solicitud).subscribe(res => {
					console.log(res)
					this.openSnackBar(res,'Entendido')
					// location.reload();
				},error => {
					this.openSnackBar(error.error,'Entendido')

					// location.reload();
				})
			}



	}
	guardar() {
		let solicitud = this.SolicitanteFormulario.getRawValue()
		solicitud.ListaDatosAval = [solicitud.ListaDatosAval]
		solicitud.ListaDatosAval.forEach(aval => {
			if(  aval.Direccion.Direcciones_CalleID !== null) {
				aval.Direccion.Direcciones_CalleID = aval.Direccion.Direcciones_CalleID.ID
			}
			if(aval.Direccion.Direcciones_LocalidadID !== null) {
				aval.Direccion.Direcciones_LocalidadID = aval.Direccion.Direcciones_LocalidadID.ID
			}
			if(  aval.Empresa_Direccion.Direcciones_CalleID !== null) {
				aval.Empresa_Direccion.Direcciones_CalleID = aval.Empresa_Direccion.Direcciones_CalleID.ID
			}
			if(aval.Empresa_Direccion.Direcciones_LocalidadID !== null) {
				aval.Empresa_Direccion.Direcciones_LocalidadID = aval.Empresa_Direccion.Direcciones_LocalidadID.ID
			}

		});
		solicitud.ListaReferenciasFamiliares.forEach(refFamiliar => {
			if(  refFamiliar.Direccion.Direcciones_CalleID !== null) {
				refFamiliar.Direccion.Direcciones_CalleID = refFamiliar.Direccion.Direcciones_CalleID.ID
			}
			if(refFamiliar.Direccion.Direcciones_LocalidadID !== null) {
				refFamiliar.Direccion.Direcciones_LocalidadID = refFamiliar.Direccion.Direcciones_LocalidadID.ID
			}
		});
		solicitud.ListaReferenciasPersonales.forEach(refPersona => {
			if(  refPersona.Direccion.Direcciones_CalleID !== null) {
				refPersona.Direccion.Direcciones_CalleID = refPersona.Direccion.Direcciones_CalleID.ID
			}
			if(refPersona.Direccion.Direcciones_LocalidadID !== null) {
				refPersona.Direccion.Direcciones_LocalidadID = refPersona.Direccion.Direcciones_LocalidadID.ID
			}
		});
		if(  solicitud.DatosSolicitante.Direccion.Direcciones_CalleID !== null) {
			solicitud.DatosSolicitante.Direccion.Direcciones_CalleID = solicitud.DatosSolicitante.Direccion.Direcciones_CalleID.ID
		}
		if(  solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID !== null) {
			solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID = solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID.ID
		}
		console.log(solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID)
		if(solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID !== null) {
			solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID = solicitud.DatosEscolaresLaborales.DatosEscolares_EscuelaID.ID
		}

		// solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID = solicitud.DatosSolicitante.Direccion.Direcciones_LocalidadID.ID

		solicitud.PersonasVivienda.ListaEgresoMensuales = solicitud.PersonasVivienda.ListaEgresoMensuales.filter(egreso => {
			return egreso.EgresoMonto > 0 ? true : false;
		})
		solicitud.PersonasVivienda.ListaEgresoFamiliares = solicitud.PersonasVivienda.ListaEgresoFamiliares.filter(egreso => {
			return egreso.EgresoMonto > 0 ? true : false;
		})

		// solicitud.PersonasVivienda.ListaEgresoFamiliares = solicitud.PersonasVivienda.ListaEgresoMensuales
		let validation = true
		this.serviciosSolicitud.guardar(solicitud).subscribe(res => {
			console.log(res)
			this.openSnackBar(res,'Entendido')
			// location.reload();
		},error => {
			this.openSnackBar(error.error.Message,'Entendido')
			// location.reload();
		})
	}
	obtenerListaEstados() {
		this.serviciosGenerales.listadoEstados().subscribe(res => {
			this.isloadingEstados = true
			this.estados = res;
		});
	}
	get ReferenciasFamiliaresArray(): FormArray {
		return this.SolicitanteFormulario.get('ListaReferenciasFamiliares') as FormArray
	}
	get ListaReferenciasPersonalesArray(): FormArray {
		return this.SolicitanteFormulario.get('ListaReferenciasPersonales') as FormArray
	}
	get ListaPersonasvivienda (): FormArray {
		return this.SolicitanteFormulario.get('PersonasVivienda').get('ListaPersonasVivienda') as FormArray
	}
	get DocumentosArray(): FormArray {
		return this.SolicitanteFormulario.get('ListaDocumentos') as FormArray
	}
	listaPersonaVivienda (persona): FormGroup {



		let personaVivienda =  this.formBuilder.group({
			PersonaVivienda_IngresoMonto: [persona.PersonaVivienda_IngresoMonto, ''],
			PersonaVivienda_Ingreso_Tipo_ID: [persona.PersonaVivienda_Ingreso_TipoID , ''],
			PersonaVivienda_OtroIngresoMonto: [persona.PersonaVivienda_IngresoMonto , ''],
			PersonaVivienda_OtroIngreso_Origen: [persona.PersonaVivienda_OtroIngreso_Origen , ''],
			PersonaVivienda_Otros_Ingre_Tipo: [persona.PersonaVivienda_Otros_Ingre_Tipo , ''],
			PersonaVivienda_MontoAportacion: [persona.PersonaVivienda_OtroIngresoMonto , ''],

			Persona_OcupacionID: [persona.Persona_OcupacionID, ''],
			Persona_OficioID: [persona.Persona_OficioID, ''],
			Personas_ApellidoMaterno: [persona.Surname , ''],
			Personas_ApellidoPaterno: [persona.Lastname , ''],
			Personas_CURP: [persona.Curp , ''],
			Edad: [persona.Edad , ''],
			Personas_FechaNacimiento: [persona.Personas_FechaNacimiento,''],
			Personas_Genero: [persona.Personas_Genero , ''],
			Personas_Nombre: [persona.Name , ''],
			SolicitantePersona_ParentescoID: [persona.SolicitantePersona_ParentescoID , ''],

		})

		return personaVivienda;
	}


	listaReferenciasFamiliares(): FormGroup {
		let referencia = this.formBuilder.group({
			SolicitantePersona_ParentescoID: ['',''],
			Direccion: this.formBuilder.group({
				Direcciones_EntidadFederativaID: ['', ''],
				Direcciones_MunicipioID: ['', ''],
				Direcciones_LocalidadID: ['', ''],
				Direcciones_CodigoPostal: ['', ''],
				Direcciones_ColoniaID: ['', ''],
				Direcciones_CalleID: ['',''],
				Direcciones_AsentamientoID: ['', ''],
				Direcciones_TipoAsentamientoID:  ['',  ''],
				Direcciones_CarreteraID: ['', ''],
				Direcciones_CaminoID: ['', ''],
				Direcciones_NoExterior: ['', ''],
				Direcciones_NoInterior: ['',''],
				Direcciones_Calle: ['',''],
				Direcciones_CiudadID: ['', '']
			}),
			DatosContacto_TelefonoFijo: ['', ''],
			DatosContacto_TelefonoCelular: ['', ''],
			confirmarCelular: ['',''],
			Personas_CURP: ['', ''],
			Personas_Nombre: ['', ''],
			Personas_ApellidoPaterno: ['', ''],
			Personas_ApellidoMaterno: ['', ''],
			Personas_EntidadFederativaID: ['', ''],
			Personas_MunicipioID: ['', ''],
			Personas_PaisID: ['', ''],
			Personas_EstadoCivilID: ['', ''],
			Persona_OcupacionID: ['',  ''],
			Personas_Edad: ['', ''],
			Personas_Genero: ['',''],
			Personas_FechaNacimiento: ['', ''],

		})

    	return referencia
	}
	setlistaReferenciasFamiliares(persona): FormGroup {
		console.log('valor de la persona ' , + persona.Direcciones_CiudadID)
		let referencia = this.formBuilder.group({
			SolicitantePersona_ParentescoID: [persona.SolicitantePersona_ParentescoID,''],
			Direccion: this.formBuilder.group({
				Direcciones_EntidadFederativaID: [persona.Direccion.Direcciones_EntidadFederativaID,''],
				Direcciones_MunicipioID: [persona.Direccion.Direcciones_MunicipioID,''],
				Direcciones_LocalidadID: [persona.Direccion.Direcciones_LocalidadID,''],
				Direcciones_CodigoPostal: [persona.Direccion.Direcciones_CodigoPostal,''],
				Direcciones_ColoniaID: [persona.Direccion.Direcciones_ColoniaID,''],
				Direcciones_CalleID: [persona.Direccion.Direcciones_CalleID, ''],
				Direcciones_AsentamientoID: [persona.Direccion.Direcciones_AsentamientoID,''],
				Direcciones_TipoAsentamientoID:  [persona.Direccion.Direcciones_TipoAsentamientoID, ''],
				Direcciones_CarreteraID: [persona.Direccion.Direcciones_CarreteraID,''],
				Direcciones_CaminoID: [persona.Direccion.Direcciones_CaminoID,''],
				Direcciones_NoExterior: [persona.Direccion.Direcciones_NoExterior,''],
				Direcciones_NoInterior: [persona.Direccion.Direcciones_NoInterior,''],
				Direcciones_Calle: [persona.Direccion.Direcciones_Calle, ''],
				Direcciones_CiudadID: [+persona.Direcciones_CiudadID,'']
			}),
			DatosContacto_TelefonoFijo: [persona.DatosContacto_TelefonoFijo,''],
			DatosContacto_TelefonoCelular: [persona.DatosContacto_TelefonoCelular,''],
			Personas_CURP: [persona.Personas_CURP,''],
			Personas_Nombre: [persona.Personas_Nombre,''],
			Personas_ApellidoPaterno: [persona.Personas_ApellidoPaterno,''],
			Personas_ApellidoMaterno: [persona.Personas_ApellidoMaterno,''],
			Personas_EntidadFederativaID: [persona.Personas_EntidadFederativaID,''],
			Personas_MunicipioID: [persona.Personas_MunicipioID,''],
			Personas_PaisID: [persona.Personas_PaisID,''],
			Personas_EstadoCivilID: [persona.Personas_EstadoCivilID,''],
			Personas_Genero: [persona.Personas_Genero, ''],
			Persona_OcupacionID: [persona.Persona_OcupacionID, ''],
			Personas_Edad: [persona.Personas_Edad, ''],
			confirmarCelular: ['',''],

			Personas_FechaNacimiento: [persona.Personas_FechaNacimiento, ''],
		})


    	return referencia
	}
	crearFormulario () {
		this.SolicitanteFormulario = this.formBuilder.group({
			DatosSolicitante: this.formBuilder.group({
				DatosContacto_TelefonoFijo: ['', ''],
				DatosContacto_TelefonoCelular: ['', ''],
				DatosContacto_Correo: ['', ''],
				DatosContacto_Correo_Confimacion: ['', ''],
				AplicaDiscapacidades: [0, ''],
				ListaDiscapacidades: ['', ''],
				Solicitante_SituacionPadreID: [1002, ''],
				Solicitante_SituacionMadreID: [1002, ''],
				Personas_TiempoResidencia: ['', ''],
				Personas_CURP: ['', ''],
				Personas_Nombre: ['', ''],
				Personas_ApellidoPaterno: ['',''],
				Personas_ApellidoMaterno: ['', ''],
				Personas_EntidadFederativaID: [0 , ''],
				Personas_MunicipioID: [0 , ''],
				Personas_PaisID: [0 ,''],
				Personas_EstadoCivilID: [0 , ''],
				Personas_Genero: ['', ''],
				Personas_Edad: ['', ''],
				Personas_FechaNacimiento: ['', ''],
				confirmarCelular: ['', ''],
				Persona_RFC: ['',''],
				Direccion: this.formBuilder.group({
					Direcciones_EntidadFederativaID: [0, ''],
					Direcciones_LocalidadID:  ['', ''],
					Direcciones_CodigoPostal:  ['', ''],
					Direcciones_CaminoID:  [0, ''],
					Direcciones_MunicipioID: [0, ''],
					Direcciones_CalleID:  ['' , ''],
					Direcciones_TipoAsentamientoID:  [0 , ''],
					Direcciones_AsentamientoID:  [0 , ''],
					Direcciones_CarreteraID:  [0 , ''],
					Direcciones_NoExterior:  ['', ''],
					Direcciones_NoInterior:  ['', ''],
					Direcciones_Calle:  ['', ''],
					Direcciones_Latitud:  [21.0181, ''],
					Direcciones_Longitud:  [-101.258, ''],
					Direcciones_CiudadID: ['', '']

				})

			}),
			DatosPadre: this.formBuilder.group({
				Personas_CURP: ['', ''],
				Personas_Nombre: ['', ''],
				Personas_ApellidoPaterno: ['', ''],
				Personas_ApellidoMaterno: ['', ''],
				Personas_EntidadFederativaID: [0, ''],
				Personas_MunicipioID: [0, ''],
				Personas_PaisID: [0, ''],
				Personas_EstadoCivilID: [0, ''],
				Personas_Genero: ['', ''],
				Personas_FechaNacimiento: ['', ''],
				Personas_Edad: ['', ''],
			}),
			DatosMadre: this.formBuilder.group({
				Personas_CURP: ['', ''],
				Personas_Nombre: ['', ''],
				Personas_ApellidoPaterno: ['', ''],
				Personas_ApellidoMaterno: ['', ''],
				Personas_EntidadFederativaID: [0, ''],
				Personas_MunicipioID: [0, ''],
				Personas_PaisID: ['', ''],
				Personas_EstadoCivilID: ['', ''],
				Personas_Genero: ['', ''],
				Personas_FechaNacimiento: ['', ''],
				Personas_Edad: ['', ''],
			}),
			DatosTutor: this.formBuilder.group({
				SolicitantePersona_ParentescoID: ['', ''],
				Personas_CURP: ['', ''],
				Personas_Nombre: ['', ''],
				Personas_ApellidoPaterno: ['', ''],
				Personas_ApellidoMaterno: ['', ''],
				Personas_EntidadFederativaID: [0, ''],
				Personas_MunicipioID: [0, ''],
				Personas_PaisID: [0, ''],
				Personas_EstadoCivilID: [0, ''],
				Personas_Genero: ['', ''],
				Personas_FechaNacimiento: ['', ''],
				Personas_Edad: ['', ''],
			}),
			ListaDatosAval: this.formBuilder.group({
				Direccion: this.formBuilder.group({
					Direcciones_EntidadFederativaID: [0,  ''],
					Direcciones_LocalidadID:  ['',  ''],
					Direcciones_CodigoPostal:  ['',  ''],
					Direcciones_CaminoID:  [0,  ''],
					Direcciones_MunicipioID: [0,  ''],
					Direcciones_CalleID:  ['',  ''],
					Direcciones_TipoAsentamientoID:  [0,  ''],
					Direcciones_AsentamientoID:  [0,  ''],
					Direcciones_CarreteraID:  [0,  ''],
					Direcciones_NoExterior:  ['',  ''],
					Direcciones_NoInterior:  ['',  ''],
					Direcciones_Calle:  ['', ''],
					Direcciones_Latitud:  ['', ''],
					Direcciones_Longitud:  ['', ''],
					Direcciones_CiudadID: ['', '']
				}),
				Persona_RFC: ['',  ''],
				SolicitantePersona_ParentescoID: [0,  ''],
				DatosContacto_TelefonoFijo: ['',  ''],
				DatosContacto_TelefonoCelular: ['',  ''],
				Persona_OcupacionID: [0 ,  ''],
				Persona_OficioID: [0 ,  ''],
				Persona_Ingresos: ['',  ''],
				Persona_Empresa: ['',  ''],
				confirmarCelular: ['',  ''],
				Empresa_Direccion: this.formBuilder.group({
					Direcciones_EntidadFederativaID: [0,  ''],
					Direcciones_LocalidadID: ['',  ''],
					Direcciones_CodigoPostal: ['',  ''],
					Direcciones_CaminoID: [0,  ''],
					Direcciones_MunicipioID: [0,  ''],
					Direcciones_CalleID: ['',  ''],
					Direcciones_TipoAsentamientoID: [0,  ''],
					Direcciones_AsentamientoID: [0,  ''],
					Direcciones_CarreteraID: [0,  ''],
					Direcciones_NoExterior: ['',  ''],
					Direcciones_NoInterior: ['',  ''],
					Direcciones_Calle: ['', ''],
					Direcciones_CiudadID: ['', '']
				}),
				Empresa_Telefono: ['',  ''],
				Empresa_Observaciones: ['',  ''],
				Personas_CURP: ['',  ''],
				Personas_Nombre: ['',  ''],
				Personas_ApellidoPaterno: ['',  ''],
				Personas_ApellidoMaterno: ['',  ''],
				Personas_EntidadFederativaID: ['',  ''],
				Personas_MunicipioID: ['',  ''],
				Personas_PaisID: ['', ''],
				Personas_EstadoCivilID: ['',  ''],
				Personas_Genero: ['',  ''],
				Personas_FechaNacimiento: ['',  ''],
				Personas_Edad: ['', ''],
			}),
			ListaReferenciasFamiliares: this.formBuilder.array([
			]),
			ListaReferenciasPersonales:this.formBuilder.array([
			]),
			PersonasVivienda: this.formBuilder.group({
				ListaPersonasVivienda: this.formBuilder.array([

				]),
				ListaEgresoMensuales: this.formBuilder.array([

				]),
				ListaEgresoFamiliares: this.formBuilder.array([

				]),

			}),
			DatosEscolaresLaborales :this.formBuilder.group({
				DatosEscolares_Grado_Estudios_ID: ['',  ''],
				DatosEscolares_EscuelaID: ['',  ''],
				DatosEscolares_CarreraID: ['',  ''],
				DatosEscolares_TipoPeriodoID: ['',  ''],
				DatosEscolares_PeriodoActual: ['',  ''],
				DatosEscolares_TotalPeriodos: ['',  ''],
				DatosEscolares_Promedio: ['',  ''],
				DatosLaborales_Ocupacion_ID : ['',  ''],
				DatosLaborales_Empresa : ['',  ''],
				DatosLaborales_Telefono : ['',  ''],
				DatosLaborales_OficioID: ['', ''],
				DatosLaborales_IngresosMensuales: ['',  ''],

			}),

			PreguntasUnicas: this.formBuilder.group({

			}),
			ConvocatoriaID: [1001,''],
			TramiteID: [null, ''],

			ListaDocumentos: this.formBuilder.array([])
		})

	}

	setSolicitud (solicitud) {
		const {DatosSolicitante,
				 DatosPadre,
				 DatosMadre,
				 DatosTutor ,
				 DatosEscolaresLaborales,
				 PersonasVivienda,
				 ListaReferenciasPersonales,
				 ListaReferenciasFamiliares,
				 ListaDatosAval,
				 TramiteID,
				 ListaDocumentos} = solicitud
		this.personaVivienda = PersonasVivienda
		this.SolicitanteFormulario.patchValue({
			DatosSolicitante,
			DatosPadre: DatosPadre !== null ? DatosPadre: [],
			DatosMadre: DatosMadre !== null ? DatosMadre : [],
			DatosTutor: DatosTutor !== null ? DatosTutor : [],
			DatosEscolaresLaborales,
			ListaDatosAval: ListaDatosAval.length === 1 ? ListaDatosAval[0] : [],
			ListaReferenciasPersonales,
			ListaReferenciasFamiliares,
			PersonasVivienda,
			TramiteID,
			ListaDocumentos: ListaDocumentos !== null ? ListaDocumentos: [],

		},{emitEvent: false});
		ListaReferenciasFamiliares.forEach(persona => {
			this.ReferenciasFamiliaresArray.push(this.setlistaReferenciasFamiliares(persona))
			this.curpsEnPersonaVivienda.push(persona.Personas_CURP)
		});
		ListaReferenciasPersonales.forEach(persona => {
			this.ListaReferenciasPersonalesArray.push(this.setlistaReferenciasFamiliares(persona))
		});
		PersonasVivienda.ListaPersonasVivienda.forEach(persona => {
			this.ListaPersonasvivienda.push(this.listaPersonaVivienda(persona));
		});
		if(!this.esEdicion) {
			this.ListaPersonasvivienda.disable()
		}
		if(ListaDocumentos !== null){
			this.obtenerDocumentos()
			ListaDocumentos.forEach((documento) => {
				this.archivosId.push(documento.ArchivoId)
				this.fileNames.push(documento.Nombre)
				this.obtenerImagen(documento.ArchivoId);
			});

		}
		this.SolicitanteFormulario.get('PersonasVivienda').patchValue(PersonasVivienda)
		this.tieneCURPSolicitante = true
		this.verSituacionPadres()
		this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosSolicitante.Personas_CURP').value)
	}
	habilitarPestanas(pestanas) {
		console.log(pestanas)
		this.tieneCURPSolicitante = true
		this.curpsEnSolicitud.push(this.SolicitanteFormulario.get('DatosSolicitante.Personas_CURP').value)
		this.verSituacionPadres()
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 6000,
		});
	}
	irArriba() {
		window.scroll(0,0);
	}
	agregarReferencias(e) {
		this.agregarReferencia(true)
		this.agregarReferencia(false)
	}

	ListaDocumentos(): FormGroup {
		const documento = this.formBuilder.group({
			DocumentoId : ['',''],
       		ArchivoId : ['',''],
			//Nombre: ['','']
		})
		return documento;
	}

	setListaDocumentos(docId, archivoId): FormGroup {
		const documento = this.formBuilder.group({
			DocumentoId: [docId, ''],
			ArchivoId: [archivoId, ''],
			Nombre: ['','']
		})
		return documento
	}

	/* setListaDocumentosSolicitud(doc): FormGroup {
		console.log('ID ARCHIVO: ', doc.ArchivoId)
		this.imgService.obtenerImagen(doc.ArchivoId).subscribe(data =>{
			console.log('seervicio de obtener img: ', data)
		})
		return this.setListaDocumentos(doc.DocumentoId, doc.ArchivoId)
	} */

	obtenerImagen(archivoId){
		if(archivoId !== 0 && archivoId !== ""){
			this.docsUrl.push('http://187.191.30.142:8089/api/imagen/obtener/' + archivoId);
		}else this.docsUrl.push('')
	}


	imprimirDocs(){
		console.log('Documentos desde solicitud', this.SolicitanteFormulario.get('ListaDocumentos').value);
	}
	obtenerDocumentos(){
		this.docsProps = []
		this.archivosId = []
		this.docsUrl  =  []
		this.fileNames = []
		this.convocatoriaService.obtenerDocumentosRequeridos(this.SolicitanteFormulario.get('ConvocatoriaID').value)
			.subscribe(docs=>{
				while (this.DocumentosArray.length !== 0) {
					this.DocumentosArray.removeAt(0)
				  }
				docs.forEach((d) => {
					this.docsProps.push({nombre: d.Nombre, extension: d.Extension});
					this.DocumentosArray.push(this.setListaDocumentos(d.Docto_ID, ''))

				})
			});
	}
	resetAll(curp){
		this.SolicitanteFormulario.patchValue(this.prevFormData, {emitEvent:false});
		this.SolicitanteFormulario.get('DatosSolicitante').get('Personas_CURP').setValue(curp,{emitEvent:false})

		this.SolicitanteFormulario.get('ListaReferenciasFamiliares').value.forEach((persona, index) => {
			if(persona.Personas_CURP !== "") {
				this.ReferenciasFamiliaresArray.removeAt(index);
			}
		});

		this.SolicitanteFormulario.get('ListaReferenciasPersonales').value.forEach((persona, index) => {
			if(persona.Personas_CURP !== "") {
				this.ListaReferenciasPersonalesArray.removeAt(index);
			}
		});

		this.SolicitanteFormulario.get('PersonasVivienda').get('ListaPersonasVivienda').value.forEach((persona, index)=>{
			this.ListaPersonasvivienda.removeAt(index);
		});

		this.obtenerDocumentos();

		this.personaVivienda.ListaEgresoMensuales.forEach((persona, index)=>{
			this.personaVivienda.ListaEgresoMensuales[index].EgresoMonto = 0
		});

		this.personaVivienda.ListaEgresoFamiliares.forEach((persona, index)=>{
			this.personaVivienda.ListaEgresoFamiliares[index].EgresoMonto = 0
		});

		this.child.crearEgresosMensualesReset(this.personaVivienda);
		this.child.crearEgresosFamiliaresReset(this.personaVivienda);
	}
}
